module.exports = __webpack_public_path__ + "img/inception_eng_assessment.c333b926.svg";